// extracted by mini-css-extract-plugin
module.exports = {"loading":"list_loading__1Ubrr"};